export enum LCOnboardingTrackEvent {
  LC_CHANGE_TYPE_OF_TEACHER_CLICK = 'LC_change_type_of_teacher_click',
  LC_CHANGE_TYPE_OF_TEACHER_CONFIRM_NATIVE = 'LC_change_type_of_teacher_native',
  LC_CHANGE_TYPE_OF_TEACHER_CONFIRM_BILINGUAL = 'LC_change_type_of_teacher_bilingual',
  LC_CHANGE_TYPE_OF_TEACHER_X = 'LC_change_type_of_teacher_x',
}



// WEBPACK FOOTER //
// ./ts/app/shared/types/lc-onboarding-track-event.ts